import React, { useState, useEffect } from "react";
import "../css/AdminDashboard.css";
import { FaUsers, FaClipboardCheck, FaClock, FaBriefcase, } from "react-icons/fa";
import { Pie, Doughnut, Bar, } from "react-chartjs-2";
import axios from 'axios'

import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend, } from "chart.js";
import { FaTruck } from "react-icons/fa6";
import { MdOutlinePerson4 } from "react-icons/md";
import { FaTractor } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { FaTools, FaClipboardList } from "react-icons/fa";
import { FaTicketAlt } from "react-icons/fa";


ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);



function AdminDashboard({ token }) {
  const navigate = useNavigate();


  const pieData = {
    labels: ["Engineering", "Sales", "HR", "Marketing", "Finance"],
    datasets: [
      {
        data: [45, 25, 15, 10, 5],
        backgroundColor: [
          "#6C7BFF",
          "#38BDF8",
          "#34D399",
          "#D9F33B",
          "#FFA63D",
        ],
      },
    ],
  };

  const doughnutData = {
    labels: ["Accept ", "Reject", "Success"],
    datasets: [
      {
        data: [55, 35, 10],
        backgroundColor: [
          "#5B6FD6",
          "#39B8E0",
          "#34D399",
        ],
      },
    ],
  };

  // const barData = {
  //   labels: [
  //     "Engineering",
  //     "Sales",


  //   ],
  //   datasets: [
  //     {
  //       data: [4, 3, 5],
  //       backgroundColor: [
  //         "#5B6FD6",
  //         "#39B8E0",
  //         "#34D399",
  //         "#D9F33B",
  //         "#FFA63D",
  //       ],
  //     },
  //   ],
  // };





  const [getUser, setGetUser] = useState([]);
  const [getDriver, setGetrDriver] = useState([]);
  const [getDealer, setGetDealer] = useState([]);
  const [list, setList] = useState([]);
  const [withdrawalList, setWithdrawalList] = useState([]);
  const [customerSphere, setCustomerSphere] = useState([]);
  const [custMachineEnq, setCustMachineEnq] = useState([]);
  const [support, setSupport] = useState([]);
  const [dealerWithdrawal, setDealerWithdrawal] = useState([]);


  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const currentMonthUsers = getUser.filter((user) => {
    const createdDate = new Date(
      user.created_at || user.createdAt || user.created_on
    );

    return (
      createdDate.getMonth() === currentMonth &&
      createdDate.getFullYear() === currentYear
    );
  });


  const currentMonthDealers = getDealer.filter((dealer) => {
    const date = new Date(
      dealer.created_at || dealer.created_on || dealer.createdAt
    );

    return (
      date.getMonth() === currentMonth &&
      date.getFullYear() === currentYear
    );
  });

  const currentMonthDrivers = getDriver.filter((driver) => {
    const date = new Date(
      driver.created_on
    );

    return (
      date.getMonth() === currentMonth &&
      date.getFullYear() === currentYear
    );
  });

  const currentMonthVehicles = list.filter((vehicle) => {
    const date = new Date(
      vehicle.added_on || vehicle.created_on || vehicle.createdAt
    );

    return (
      date.getMonth() === currentMonth &&
      date.getFullYear() === currentYear
    );
  });


  const machineClosedSales = custMachineEnq?.filter(
    (item) => item.enquire_status === "Closed"
  ) || [];


  const sphereClosedSales = customerSphere?.filter(
    (item) => item.enquire_status === "Closed"
  ) || [];


  const machineSaleTotal = machineClosedSales.reduce(
    (sum, item) => sum + Number(item.sell_price || 0),
    0
  );


  const sphereSaleTotal = sphereClosedSales.reduce(
    (sum, item) => sum + Number(item.sell_price || 0),
    0
  );


  const totalSale = machineSaleTotal + sphereSaleTotal;


  const barData = {
    labels: [
      "Machine Sale",
      "Sphere Parts Sale",
      "Total Sale"
    ],

    datasets: [
      {
        label: "Sales Amount",

        data: [
          machineSaleTotal,
          sphereSaleTotal,
          totalSale
        ],

        backgroundColor: [
          "#2563eb",
          "#16a34a",
          "#f59e0b"
        ],

        borderRadius: 10,
      }
    ]
  };


  const fetchUser = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-users",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setGetUser(result);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDriver = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-driver",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setGetrDriver(result);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchDealer = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-dealers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = res.data;

      const filteredSorted = result
        .filter((item) => item.id !== 1)
        .sort((a, b) => b.id - a.id);

      setGetDealer(filteredSorted);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMachineList = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-machine-list",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setList(result);
    } catch (error) {
      console.log(error);
    }
  };



  const fetchDriverWithdrawal = async () => {
    try {
      const res = await axios.get(`https://api.krimotion.in/fetch-driver-withdrawal`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setWithdrawalList(result);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchDealerWithdrawal = async () => {
    try {
      const res = await axios.get(`https://api.krimotion.in/fetch-dealer-withdrawal`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setDealerWithdrawal(result);
    } catch (error) {
      console.log(error);
    }
  };



  const fetchCutMachineEnquiry = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-custumer-enquiry",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;
      setCustMachineEnq(result);


    } catch (error) {
      console.log(error);
    }
  };


  const fetchCutSpereEnquiry = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-customer-part-enquiry",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;


      setCustomerSphere(result);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchTicket = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/fetch-ticket`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSupport(res.data);

    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchUser();
    fetchDriver();
    fetchDealer();
    fetchMachineList();
    fetchDriverWithdrawal();
    fetchCutMachineEnquiry();
    fetchCutSpereEnquiry();
    fetchTicket();
    fetchDealerWithdrawal();
  }, []);

  const closedTickets = support?.filter(
    (ticket) => ticket.status === "Pending"
  ) || [];


  const pendingWithdrawals = [
  ...(withdrawalList || []).map((item) => ({
    ...item,
    request_by: "Driver",
    name: item.d_name,
    date: item.d_withdraw,
  })),

  ...(dealerWithdrawal || []).map((item) => ({
    ...item,
    request_by: "Dealer",
    name: item.d_name,
    date: item.withdraw_date || item.d_withdraw,
  })),
].filter(
  (item) => item.pay_status === "Pending"
);


  const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

  return (
    <div className="container-fluid py-4">

      <div className="row g-4">


        <div
          className="col-xl-3 col-md-6"
          onClick={() => navigate("/admin/users")}
          style={{ cursor: "pointer" }}
        >
          <div
            className="card border-0 shadow-sm text-white h-100"
            style={{
              background: "linear-gradient(135deg,#5b6fd6,#7386f5)",
              borderRadius: "15px",
            }}
          >
            <div className="card-body">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fw-bold">Users</h5>

                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.2)",
                  }}
                >
                  <FaUsers size={24} />
                </div>
              </div>

              {/* Statistics */}
              <div>
                <h6 className="mb-2">
                  <span className="fw-normal">Total Users :</span>{" "}
                  <span className="fw-bold">{getUser.length}</span>
                </h6>

                <h6 className="mb-0">
                  <span className="fw-normal">Current Month :</span>{" "}
                  <span className="fw-bold">{currentMonthUsers.length}</span>
                </h6>
              </div>

            </div>
          </div>
        </div>


        <div
          className="col-xl-3 col-md-6"
          onClick={() => navigate("/admin/dealers")}
          style={{ cursor: "pointer" }}
        >
          <div
            className="card border-0 shadow-sm text-white h-100"
            style={{
              background: "linear-gradient(135deg,#34d399,#10b981)",
              borderRadius: "15px",
            }}
          >
            <div className="card-body">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fw-bold">Dealers</h5>

                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }}
                >
                  <MdOutlinePerson4 size={24} />
                </div>
              </div>

              <div>
                <h6 className="mb-2">
                  <span className="fw-normal">Total Dealers :</span>{" "}
                  <span className="fw-bold">{getDealer.length}</span>
                </h6>

                <h6 className="mb-0">
                  <span className="fw-normal">Current Month :</span>{" "}
                  <span className="fw-bold">{currentMonthDealers.length}</span>
                </h6>
              </div>

            </div>
          </div>
        </div>


        <div
          className="col-xl-3 col-md-6"
          onClick={() => navigate("/admin/driver")}
          style={{ cursor: "pointer" }}
        >
          <div
            className="card border-0 shadow-sm text-white h-100"
            style={{
              background: "linear-gradient(135deg,#ef4444,#dc2626)",
              borderRadius: "15px",
            }}
          >
            <div className="card-body">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fw-bold">Drivers</h5>

                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }}
                >
                  <FaTruck size={22} />
                </div>
              </div>

              <div>
                <h6 className="mb-2">
                  <span className="fw-normal">Total Drivers :</span>{" "}
                  <span className="fw-bold">{getDriver.length}</span>
                </h6>

                <h6 className="mb-0">
                  <span className="fw-normal">Current Month :</span>{" "}
                  <span className="fw-bold">{currentMonthDrivers.length}</span>
                </h6>
              </div>

            </div>
          </div>
        </div>


        <div
          className="col-xl-3 col-md-6"
          onClick={() => navigate("/admin/machine-list")}
          style={{ cursor: "pointer" }}
        >
          <div
            className="card border-0 shadow-sm text-white h-100"
            style={{
              background: "linear-gradient(135deg,#f59e0b,#d97706)",
              borderRadius: "15px",
            }}
          >
            <div className="card-body">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fw-bold">Vehicles</h5>

                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }}
                >
                  <FaTractor size={22} />
                </div>
              </div>

              <div>
                <h6 className="mb-2">
                  <span className="fw-normal">Total Vehicles :</span>{" "}
                  <span className="fw-bold">{list.length}</span>
                </h6>

                <h6 className="mb-0">
                  <span className="fw-normal">Current Month :</span>{" "}
                  <span className="fw-bold">{currentMonthVehicles.length}</span>
                </h6>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div className="row mt-4 g-4">


        <div className="col-lg-8">
          <div
            className="chart-card p-4 h-100"
            style={{
              borderRadius: "18px",
              background: "#fff",
              boxShadow: "0 8px 20px rgba(0,0,0,.08)",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="fw-bold mb-0">Sale Ratio</h4>
            </div>

            <div style={{ height: "360px" }}>
              <Bar
                data={barData}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    x: {
                      grid: {
                        display: false,
                      },
                    },
                    y: {
                      beginAtZero: true,
                      grid: {
                        color: "#f1f5f9",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>


        <div className="col-lg-4">
          <div
            className="p-4 h-100"
            style={{
              borderRadius: "18px",
              background: "#fff",
              boxShadow: "0 10px 25px rgba(0,0,0,.08)",
            }}
          >
            <h4 className="fw-bold text-center mb-4">
              Enquiry Summary
            </h4>

            <div className="d-flex flex-column gap-3">

              {/* Machine Enquiry */}
              <div
                className="card border-0 shadow-sm"
                style={{
                  borderRadius: "16px",
                  background: "linear-gradient(135deg,#EFF6FF,#DBEAFE)",
                  transition: ".3s",
                  cursor: "pointer",
                }}
                  onClick={() => navigate('/admin/customer-enq')}
              >
                <div className="card-body d-flex justify-content-between align-items-center">

                  <div>
                    <small className="text-primary fw-semibold text-uppercase">
                      Machine Enquiry
                    </small>

                    <h2 className="fw-bold mt-2 mb-0 text-dark">
                      {custMachineEnq.length}
                    </h2>
                  </div>

                  <div
                    style={{
                      width: 65,
                      height: 65,
                      borderRadius: "50%",
                      background: "#2563EB",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                    }}
                  >
                    <FaTractor size={30} />
                  </div>

                </div>
              </div>

              {/* Sphere Parts */}
              <div
                className="card border-0 shadow-sm"
                style={{
                  borderRadius: "16px",
                  background: "linear-gradient(135deg,#ECFDF5,#D1FAE5)",
                  transition: ".3s",
                  cursor: "pointer",
                }}
                  onClick={() => navigate('/admin/customer-sphere')}
              >
                <div className="card-body d-flex justify-content-between align-items-center">

                  <div>
                    <small className="text-success fw-semibold text-uppercase">
                      Sphere Parts Enquiry
                    </small>

                    <h2 className="fw-bold mt-2 mb-0 text-dark">
                      {customerSphere.length}
                    </h2>
                  </div>

                  <div
                    style={{
                      width: 65,
                      height: 65,
                      borderRadius: "50%",
                      background: "#16A34A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                    }}
                  >
                    <FaTools size={28} />
                  </div>

                </div>
              </div>

              {/* Vehicle List */}
              <div
                className="card border-0 shadow-sm"
                style={{
                  borderRadius: "16px",
                  background: "linear-gradient(135deg,#FEFCE8,#FEF3C7)",
                  transition: ".3s",
                  cursor: "pointer",
                }}
                onClick={() => navigate('/admin/machine-list')}
              >
                <div className="card-body d-flex justify-content-between align-items-center">

                  <div>
                    <small className="fw-semibold text-uppercase text-warning">
                      Total Vehicle List
                    </small>

                    <h2 className="fw-bold mt-2 mb-0 text-dark">
                      {list.length}
                    </h2>
                  </div>

                  <div
                    style={{
                      width: 65,
                      height: 65,
                      borderRadius: "50%",
                      background: "#F59E0B",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                    }}
                  >
                    <FaClipboardList size={28} />
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>



      </div>




      <div className="row mt-4 g-4">

        {/* Withdrawal List - Left Side */}
   <div className="col-lg-8">
  <div
    className="card p-4 border-0 shadow-sm"
    style={{
      borderRadius: "18px",
      background: "#fff",
    }}
  
  >

    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="fw-bold mb-0">
        Pending Withdrawal Request
      </h4>

      <span className="badge bg-warning">
        {pendingWithdrawals.length} Pending
      </span>
    </div>


    <div className="table-responsive">

      <table className="table align-middle">

        <thead>
          <tr>
            <th>Request By</th>
            <th>Name</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>


        <tbody>

          {
            pendingWithdrawals.slice(0,5).map((item,index)=>(

              <tr key={index}>

                <td>
                  <span
                    className={`badge ${
                      item.request_by === "Driver"
                      ? "bg-primary"
                      : "bg-success"
                    }`}
                  >
                    {item.request_by}
                  </span>
                </td>


                <td className="fw-semibold">
                  {item.name || "-"}
                </td>


                <td className="fw-bold">
                  ₹
                  {(
                    Number(item.amount || 0) -
                    Number(item.platform_fee || 0)
                  ).toFixed(2)}
                </td>


                <td>
                  {formatDate( item.date || "-")}
                </td>


                <td>
                  <span className="badge bg-warning">
                    {item.pay_status}
                  </span>
                </td>

              </tr>

            ))
          }


          {
            pendingWithdrawals.length === 0 && (
              <tr>
                <td
                  colSpan="5"
                  className="text-center text-muted"
                >
                  No Pending Withdrawal Request
                </td>
              </tr>
            )
          }


        </tbody>

      </table>

    </div>

  </div>
</div>




        {/* Support List - Right Side */}
        <div className="col-lg-4">

          <div
            className="card p-4 border-0 shadow-sm"
            style={{
              borderRadius: "18px",
              background: "#fff"
            }}
            onClick={() => navigate('/admin/help-support')}
          >

            <h4 className="fw-bold mb-4">
              Support Tickets
            </h4>


            {
              closedTickets.slice(0, 5).map((ticket, index) => (

                <div
                  key={index}
                  className="d-flex align-items-center mb-3"
                >

                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      background: "#fee2e2"
                    }}
                  >
                    <FaTicketAlt
                      color="#ef4444"
                      size={22}
                    />
                  </div>


                  <div className="ms-3">

                    {/* <h6 className="mb-1 fw-bold">
              {ticket.subject || "Support Ticket"}
            </h6> */}

                    <small className="text-muted">
                      {ticket.raised_by_name || ticket.name}
                    </small>

                    <br />

                    <span
                      className="badge bg-success mt-1"
                    >
                      {ticket.status}
                    </span>

                  </div>


                </div>

              ))
            }


            {
              closedTickets.length === 0 && (
                <p className="text-muted text-center mb-0">
                  No Tickets Found
                </p>
              )
            }


          </div>

        </div>



      </div>

    </div>
  );
}

export default AdminDashboard;